import React from "react";

export default class LearningPlanExamSuccessScoreUnreleased extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="learning-plan-exam-success score-unreleased">
        <div className="bordered-heading">
          <h1>{I18n.t("congratulations")}</h1>
        </div>
        <p>{I18n.t("your_exam_is_complete")}</p>
      </div>
    );
  }
}
